import { useEffect, useState } from 'react'
import { adminService } from 'core/services/adminService'
import { CaseItem } from './case-item'
import { CaseEdit } from './case-edit'
import { PurchaseHistory } from './purchase-history'
import { formatNumbers } from 'core/helpers/format-numbers'

import c from './assets/sass/cases-list.module.scss'

export const CasesList = () => {
    const [cases, setCases] = useState([])
    const [loading, setLoading] = useState(true)
    const [editing, setEditing] = useState(null)
    const [creating, setCreating] = useState(false)
    const [activeTab, setActiveTab] = useState('management') // 'management' | 'history'
    const [categoryFilter, setCategoryFilter] = useState('ALL') // 'ALL' | 'STANDOFF_2' | 'PUBG_MOBILE'

    useEffect(() => {
        loadCases()
    }, [])

    const loadCases = async () => {
        try {
            const data = await adminService.getCases()
            setCases(data.cases)
        } catch (error) {
            console.error('Failed to load cases:', error)
        } finally {
            setLoading(false)
        }
    }

    // Фильтруем кейсы по выбранной категории
    const filteredCases = categoryFilter === 'ALL' 
        ? cases 
        : cases.filter(c => c.category === categoryFilter)

    const handleEdit = (caseItem) => {
        setEditing(caseItem)
        setCreating(false)
    }

    const handleCreate = () => {
        setCreating(true)
        setEditing(null)
    }

    const handleSave = async () => {
        await loadCases()
        setEditing(null)
        setCreating(false)
    }

    const handleCancel = () => {
        setEditing(null)
        setCreating(false)
    }

    if (loading) {
        return <div className={c.loading}>Загрузка...</div>
    }

    if (editing || creating) {
        return (
            <CaseEdit
                caseData={editing}
                onSave={handleSave}
                onCancel={handleCancel}
            />
        )
    }

    return (
        <div className={c.component}>
            <div className={c.tabs}>
                <button
                    className={activeTab === 'management' ? c.tabActive : c.tab}
                    onClick={() => setActiveTab('management')}
                >
                    Управление кейсами
                </button>
                <button
                    className={activeTab === 'history' ? c.tabActive : c.tab}
                    onClick={() => setActiveTab('history')}
                >
                    История покупок
                </button>
            </div>

            {activeTab === 'management' && (
                <>
                    <button className={c.createBtn} onClick={handleCreate}>
                        + Создать кейс
                    </button>
                    
                    <div className={c.categoryFilter}>
                        <button 
                            className={categoryFilter === 'ALL' ? c.filterActive : c.filterBtn}
                            onClick={() => setCategoryFilter('ALL')}
                        >
                            Все ({cases.length})
                        </button>
                        <button 
                            className={categoryFilter === 'STANDOFF_2' ? c.filterActive : c.filterBtn}
                            onClick={() => setCategoryFilter('STANDOFF_2')}
                        >
                            STANDOFF 2 ({cases.filter(c => c.category === 'STANDOFF_2').length})
                        </button>
                        <button 
                            className={categoryFilter === 'PUBG_MOBILE' ? c.filterActive : c.filterBtn}
                            onClick={() => setCategoryFilter('PUBG_MOBILE')}
                        >
                            PUBG MOBILE ({cases.filter(c => c.category === 'PUBG_MOBILE').length})
                        </button>
                    </div>
                    
                    <div className={c.list}>
                        {filteredCases.map((cs) => (
                            <CaseItem
                                key={cs.id}
                                caseData={cs}
                                onEdit={() => handleEdit(cs)}
                                onUpdate={loadCases}
                            />
                        ))}
                    </div>
                </>
            )}

            {activeTab === 'history' && <PurchaseHistory />}
        </div>
    )
}
